module.exports = "/_next/static/images/logo-allways-982c55ddf11625520ba42377d4b23b16.svg";